import React from 'react';
import { Link } from 'react-router-dom';

const RelatedPostCard = ({ image, tags, title, createdAt, id }) => {
    return (
        <div className="card">
            <Link to={`/details/${id}`}>
                <img src={image} className="card-image" alt="" />
            </Link>
            <div className="p-4">
                <Link to={`/details/${id}`} className="text-lg post-title lws-RelatedPostTitle">
                    {title}
                </Link>
                <div className="mb-0 tags">
                    {
                        tags?.map(single => <span key={single}>#{single}, </span>)
                    }
                </div>
                <p>{createdAt}</p>
            </div>
        </div>
    );
};

export default RelatedPostCard;